import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API } from '@core/services/api.base';
import { Observable } from 'rxjs';
import { ServiceComboEntity } from 'src/app/models/service-combo.model';
import { ResponseDto } from '@core/models/response.dto';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BusinessServiceService extends API {
  /**
   * Get combos for a specific store
   * Note: The backend uses tenant service which expects x-tenant-id header
   */
  getCombosForStore(storeId: string): Observable<ServiceComboEntity[]> {
    return this.get<ServiceComboEntity[]>(
      `v1/business-service/combo/customer?storeId=${storeId}`
    );
  }
}
